import React, { useEffect, useState } from "react";
import DashboardHeader from "@/components/DashboardHeader";
import { FiEdit2 } from "react-icons/fi";
import ToggleInput from "@/components/toggle/Toggle";
import { SubmitHandler, useForm } from "react-hook-form";
import { API_ROUTES } from "@/services/environment";
import { DELETE, GET, PATCH, POST } from "@/services/api";
import Alert from "@/components/alert/Alert";
import { useAppSelector } from "@/hooks/hook";
import "react-datepicker/dist/react-datepicker.css";
import ChangesAlert from "@/components/alert/ChangesAlert";
import useError from "@/hooks/useError ";
import { DeleteIcon, EditIcon } from "@/utils/svgs";
import deleteIcon from "../assets/icons/deleteIcon.svg";
import { Button, dateFunctionUS } from "@thdinc/hpf-shared";
import _DatePicker from "react-datepicker";
import { Package, PackageType } from "@/interfaces/Package";
const DatePicker = _DatePicker as unknown as React.ComponentType<any>;

interface packagesDataInterface {
    id: string;
    name: string;
}
interface DiscountManager {
    isAdmin?: boolean;
    businessId?: string;
}

const DiscountManager: React.FC<DiscountManager> = ({ businessId, isAdmin }) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const { refreshToken } = useAppSelector((store) => store.user);
    const [selectedPackage, setSelectedPackage] = useState<
        packagesDataInterface | any
    >({ id: "All", name: "" });
    const { discounts, packages } = API_ROUTES;
    const [discountsData, setDicountsData] = useState<Array<any>>([]);
    type DateValue = Date;
    // const [validFrom, setValidFrom] = useState<DateValue>(new Date());
    const [validTill, setValidTill] = useState<DateValue>(tomorrow);

    const [fixEnabled, setfixEnabled] = useState<boolean>(false);
    const [validEnabled, setvalidEnabled] = useState<boolean>(false);
    const [packageEnabled, setpackageEnabled] = useState<boolean>(false);
    const [packagesData, setPackagesData] = useState<Array<any>>([]);

    const [loading, setLoading] = useState<boolean>(true);
    // const [error, setError] = useState<string | null>(null);
    const [modal, setModal] = useState<boolean>(false);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [editId, setEditId] = useState<string>("");
    const [activeData, setActiveData] = useState<object | null>(null);
    const [error, setCustomError] = useError();

    useEffect(() => {
        fetchData();
        // Clean-up function
        return () => {
            // Perform any clean-up (if needed)
        };
    }, []); // Empty dependency array to run effect only once on component mount

    const fetchData = async () => {
        try {
            const result = businessId ? await GET(`${discounts}?business_id=${businessId}`, refreshToken) : await GET(discounts, refreshToken);
            const packagesData = await GET(`${packages}${businessId ? '?business_id=' + businessId : ''}`, refreshToken);
            packagesData.data = packagesData?.data?.filter(
                (p: Package) => p.type === PackageType.Standard
            );
            convertPackagesData(packagesData?.data ?? []);
            setDicountsData(result?.data?.reverse());
            setLoading(false);
        } catch (err) {
            console.log(err);
            // setCustomError('discount', JSON.stringify( err));
        } finally {
            setLoading(false);
        }
    };

    const convertPackagesData = (source: any[]) => {
        setSelectedPackage(source[0]);
        setPackagesData(
            source.map((item) => ({ value: item.id, label: item.name }))
        );
    };

    const handleToggle = async (id: number, value: string) => {
        setLoading(true);
        const updatedItems = discountsData.map((item) =>
            item.id === id ? { ...item, is_active: !value } : item
        );
        setDicountsData([...updatedItems]);

        const body = {
            is_active: !value,
        };
        try {
            await PATCH(discounts + `/${id}`, body, refreshToken);

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log("Error updating item status:", error);
            // Handle error
        }
    };

    // const handleDateFrom = async (value: Date) => {
    //   setValidFrom(value);
    //   setValidTill(value);
    // };

    //form-hook
    type Inputs = {
        discountCode: string;
        bookings: number;
        fixedDiscount: number;
        discountPercentage: number;
        package: string;
    };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors, isValid },
    } = useForm<Inputs>();

    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };
    const resetAll = () => {
        // reset all the fields in the form
        setEditId("");
        setIsEdit(false);
        setActiveData(null);
        reset();
        setSelectedPackage({ id: "All", name: "All" });
        //setValidFrom(new Date());
        setValidTill(tomorrow);
        setfixEnabled(false);
        setvalidEnabled(false);
        setpackageEnabled(false);
    };

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (!loading) {
            const body = {
                name: data?.discountCode.toUpperCase().trim(),
                valid_till: formatDate(validTill),
                is_fixed_amount: fixEnabled,
                discount: fixEnabled
                    ? data?.fixedDiscount.toString()
                    : data?.discountPercentage,
                is_redeem_limit: validEnabled,
                max_redeem_limit: validEnabled ? data?.bookings : 0,
                is_all_packages: !packageEnabled,
                package_id: packageEnabled ? selectedPackage.id : "",
            };
            // update the active state for confirmation modal
            setActiveData(body);
            setModal(true);
        }
    };

    const editDiscount = (item: any) => {
        const fixed = parseInt(item.discount) / 100;
        setIsEdit(true);
        setEditId(item.id);
        setValue("discountCode", item?.name.trim());
        setpackageEnabled(!item.is_all_packages);
        setfixEnabled(item?.is_fixed_amount);
        setvalidEnabled(item?.max_redeem_limit == 0 ? false : true);
        setpackageEnabled(item.package_id != "");
        setValidTill(new Date(item.valid_till));
        setValue("bookings", item?.max_redeem_limit);
        if (item.is_fixed_amount) {
            setValue("fixedDiscount", item.discount / 100); // assuming backend stores cents
        } else {
            setValue("discountPercentage", item.discount);
        }

        // update package in drop down to displayed new value
        if (!item.is_all_packages) {
            const obj = packagesData.find((p) => p.value == item.package_id);
            setSelectedPackage({ id: obj.value, name: obj.label });
            const arr = [...packagesData.filter((p) => p.value != item.package_id)];
            arr.unshift(obj);
            setPackagesData([...arr]);
        }
    };

    const saveDetails = async () => {
        setModal(false);
        let response;
        try {
            setLoading(true);
            if (isEdit) {
                response = await PATCH(
                    `${discounts}/${editId}`,
                    businessId ? { ...activeData, business_id: businessId } : activeData,
                    refreshToken
                );
            } else {
                response = await POST(discounts, businessId ? { ...activeData, business_id: businessId } : activeData, refreshToken);
            }
            resetAll();
            setLoading(false);
            if (response?.data?.success) {
                Alert({ message: response?.data?.message });
                // reomve error on success
                setCustomError("discount", "");
                // fetch updated list again
                fetchData();
            } else {
                setCustomError("discount", response?.data?.message);
                console.log("Error adding item:", error);
            }
        } catch (error) {
            setLoading(false);
            console.log("Error adding item:", error);
            // Handle error
        }
    };

    const deleteDiscount = async () => {
        setDeleteModal(false);
        const updatedItems = discountsData.filter((item) => item.id != editId);
        // update discount list after deleting item from array
        setDicountsData([...updatedItems]);
        try {
            const response = await DELETE(discounts + `/${editId}`, refreshToken);
            Alert({ message: response?.data?.message });
            setLoading(false);
            resetAll();
        } catch (error) {
            setLoading(false);
            console.log("Error updating item status:", error);
            // Handle error
        }
    };
    const formIsValid =
        (fixEnabled && !!watch("fixedDiscount")) ||
        (!fixEnabled && !!watch("discountPercentage"));


    return (
        <div>
            <DashboardHeader title={isEdit ? "Update Discount" : "Discount Codes"} />
            <div className="flex md:flex-row flex-col  items-start justify-between gap-8">
                {/* left div */}
                <div className="bg-white rounded-3xl p-6 w-full md:w-3/5">
                    <h1 className="font-bold text-xl mb-3 text-gray-600">
                        {" "}
                        Create New Coupon
                    </h1>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="flex justify-between gap-4 sm:flex-row flex-col">
                            <div className="flex-1">
                                <p className="  text-xs mb-2 ml-2 font-semibold">
                                    Discount Code
                                </p>
                                <input
                                    maxLength={21}
                                    className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none uppercase focus:ring-1 focus:ring-primary-red text-gray-600"
                                    placeholder={"LIMITED24"}
                                    {...register("discountCode", {
                                        required: "Discount Code is required",
                                    })}
                                />
                                <p className="text-red-500 text-xs mb-2 mt-1 py-">
                                    {errors?.discountCode?.message}
                                </p>
                            </div>
                            <div className="flex-1">
                                <p className="font-semibold  text-xs mb-2 ml-2 ">
                                    Percentage Discount
                                </p>
                                <div className="relative">
                                    {fixEnabled ? (
                                        <input
                                            placeholder="0-99"
                                            disabled={true}
                                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none uppercase focus:ring-1 focus:ring-primary-red text-gray-600"
                                        />
                                    ) : (
                                        <input
                                            maxLength={2}
                                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none uppercase focus:ring-1 focus:ring-primary-red text-gray-600"
                                            placeholder="0-99"
                                            {...register("discountPercentage", {
                                                required: !fixEnabled ? "Percentage is required!" : false,
                                                pattern: !fixEnabled
                                                    ? {
                                                        value: /^(100|[1-9]?[0-9])$/,
                                                        message: "Enter a valid percentage (0–100)",
                                                    }
                                                    : undefined,
                                            })}
                                        />
                                    )}

                                    <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500">
                                        %
                                    </span>
                                </div>
                                <p className="text-red-500 text-xs mb-2 mt-1 py-">
                                    {errors?.discountPercentage?.message}
                                </p>
                            </div>
                        </div>

                        <div className="flex justify-between sm:flex-row flex-col  gap-3  items-end ">
                            <DateInput
                                label={"Valid Till"}
                                onChange={setValidTill}
                                minDate={tomorrow}
                                value={validTill.toDateString()}
                            />
                            <div className="flex-1 w-full">
                                <div className="">
                                    <div className="flex justify-between">
                                        <p className="  text-xs mb-2 ml-2 font-semibold ">
                                            Fixed Discount{" "}
                                        </p>
                                        <div>
                                            <ToggleInput
                                                onChange={() => setfixEnabled(!fixEnabled)}
                                                checked={fixEnabled}
                                            />
                                        </div>
                                    </div>

                                    {fixEnabled ? (
                                        <input
                                            type="number"
                                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none uppercase focus:ring-1 focus:ring-primary-red text-gray-600"
                                            placeholder={"0"}
                                            {...register("fixedDiscount", {
                                                required: fixEnabled ? "Fix Discount is required!" : false,
                                                min: fixEnabled ? { value: 1, message: "Discount must be greater than 0" } : undefined,
                                            })}
                                        />
                                    ) : (
                                        <input
                                            disabled={true}
                                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none uppercase focus:ring-1 focus:ring-primary-red text-gray-600"
                                            placeholder={"0"}
                                        />
                                    )}
                                </div>
                            </div>
                            {/* <img className="h-5 w-auto mt-8" src={iconToggle} /> */}
                        </div>
                        <p className="text-red-500 text-xs mb-2 mt-1 py-">
                            {errors?.fixedDiscount?.message}
                        </p>
                        <div className="flex justify-between gap-3  sm:flex-row flex-col items-end">
                            <div className="flex-1 w-full">
                                <div>
                                    <div className=" flex justify-between">
                                        <p className="font-semibold  text-xs mb-2 ml-2 ">
                                            Valid For Bookings
                                        </p>
                                        <div>
                                            <ToggleInput
                                                onChange={() => setvalidEnabled(!validEnabled)}
                                                checked={validEnabled}
                                            />
                                        </div>
                                    </div>
                                    {validEnabled ? (
                                        <input
                                            type="number"
                                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                                            placeholder={"0"}
                                            {...register("bookings", {
                                                required: "Booking number is required!",

                                                pattern: {
                                                    value: /^[1-9][0-9]*$/,
                                                    message: "Enter valid number greater then zero",
                                                },
                                            })}
                                        />
                                    ) : (
                                        <input
                                            disabled={true}
                                            className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                                            placeholder={"Unlimited"}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="mt-4  flex-1 w-full">
                                <div className="flex justify-between">
                                    <p className="font-semibold  text-xs mb-2 ml-2 ">Valid for</p>
                                    <div>
                                        <ToggleInput
                                            onChange={() => {
                                                setpackageEnabled(!packageEnabled);
                                            }}
                                            checked={packageEnabled}
                                        />
                                    </div>
                                </div>

                                <select
                                    className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                                    value={packageEnabled ? selectedPackage?.name : "All"}
                                    disabled={!packageEnabled}
                                    onChange={(e) => {
                                        setSelectedPackage({
                                            id: e.target.value,
                                            name: packagesData[e.target.selectedIndex].name,
                                        });
                                    }}
                                >
                                    {packagesData.map((option) => (
                                        <option key={option.label} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <p className="text-red-500 text-xs mb-2 mt-1 py-">
                            {errors?.bookings?.message}
                        </p>
                        <div className="flex justify-between sm:gap-7 gap-2  items-end"></div>

                        <div className="flex md:justify-between justify-center mt-4 ">
                            <div>
                                {error?.name === "discount" && (
                                    <p className="text-primary-red text-center mt-">
                                        {error.message}
                                    </p>
                                )}
                            </div>

                            <div className="text-end w-full">
                                {isEdit && (
                                    <Button
                                        classes="mr-4 bg-slate-400"
                                        onClick={() => {
                                            resetAll();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                )}

                                <button
                                    className={`text-center px-6 rounded-full py-2 ${formIsValid
                                        ? "bg-primary-red hover:bg-primary-red-button-hover text-white"
                                        : "bg-gray-300 text-gray-500  "
                                        } `}
                                    disabled={loading || !formIsValid}
                                    type="submit"
                                >
                                    {isEdit ? "Update" : "Save"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                {/* right div */}
                {/* <div className="bg-white rounded-2xl border p-2 md:p-6 md:w-4/6  overflow-y-auto h-96 "> */}
                <div className="grid sm:grid-cols-2 grid-cols-1 w-full md:w-4/6 gap-5 xl:gap-8">
                    {discountsData.map((item, index) => {
                        return (
                            <div key={index} className="rounded-3xl  bg-white  p-4">
                                <div className="flex justify-between items-center">
                                    <p className="font-bold text-3xl text-gray-500/90 ">
                                        {item?.is_fixed_amount
                                            ? "$" + item.discount / 100
                                            : item.discount + "%"}
                                    </p>
                                    <ToggleInput
                                        onChange={() => handleToggle(item.id, item.is_active)}
                                        checked={item.is_active}
                                    />
                                </div>
                                <p className="text-gray-500 py-3">{item?.name}</p>
                                <div className="  flex justify-between flex-wrap gap-2">
                                    <p className="text-sm tracking-wider">
                                        {" "}
                                        {dateFunctionUS(item?.valid_till)}
                                    </p>
                                    <div className="flex gap-2 text-xs items-center">
                                        <div
                                            onClick={() => {
                                                editDiscount(item);
                                            }}
                                            className="cursor-pointer flex items-center gap-2 bg-p-gray py-1  px-3 rounded-full"
                                        >
                                            <FiEdit2 />
                                            Edit
                                        </div>
                                        <div
                                            onClick={() => {
                                                setEditId(item?.id), setDeleteModal(true);
                                            }}
                                            className="cursor-pointer p-2 bg-p-gray  rounded-full w-7 h-7 flex flex-col items-center justify-center "
                                        >
                                            <img src={deleteIcon} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* </div> */}
            </div>
            {/* <div className="relative overflow-x-auto  p-2  h-96 shadow-md border rounded-xl  overflow-y-auto max-h-[700px]">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" className="p-2 text-primary-red">
                  Sr#.
                </th>
                <th className="p-2 text-primary-red">Discount Code</th>
                <th className="p-2 text-primary-red min-w-28">
                  Discount ($/%)
                </th>
                <th className="p-2 text-primary-red">Expiry</th>
                <th className="p-2 text-primary-red">Status</th>
                <th className="p-2 text-primary-red">Actions</th>
              </tr>
            </thead>
            <tbody>
              {discountsData.length > 0 ? (
                discountsData.map((item, index) => {
                  return (
                    <tr key={index} className="border-b border-gray-200 ">
                      <th
                        scope="row"
                        className="max-w-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                      >
                        {index + 1}
                      </th>
                      <td className="p-2">{item?.name}</td>
                      <td className="p-2">
                        {item?.is_fixed_amount
                          ? "$" + item.discount / 100
                          : item.discount + "%"}
                      </td>
                      <td className="p-2">
                        {dateFunctionUS(item?.valid_till)}
                      </td>
                      <td className="p-2">
                        <ToggleInput
                          onChange={() => handleToggle(item.id, item.is_active)}
                          checked={item.is_active}
                        />
                      </td>
                      <td className="p-2 flex justify-center items-center">
                        <div
                          onClick={() => {
                            editDiscount(item);
                          }}
                          className="cursor-pointer"
                        >
                          <EditIcon />
                        </div>
                        <div
                          onClick={() => {
                            setEditId(item?.id), setDeleteModal(true);
                          }}
                          className="cursor-pointer ml-4"
                        >
                          <DeleteIcon />
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <p className="col-span-11 text-center font-semibold text-gray-400 mt-4">
                  No Discount Codes
                </p>
              )}
            </tbody>
          </table>
        </div> */}
            <ChangesAlert
                title={"Save Changes"}
                desc={`Are you sure you want to save this changes?`}
                positiveButtonText={"Yes"}
                negativeButtonText={"Cancel"}
                handleDiscardChanges={() => {
                    setModal(false);
                }}
                handleSaveChanges={saveDetails}
                isOpen={modal}
            />

            <ChangesAlert
                title={"Delete Discount"}
                desc={`Are you sure you want to delete this discount?`}
                positiveButtonText={"Yes"}
                negativeButtonText={"Cancel"}
                handleDiscardChanges={() => {
                    setDeleteModal(false);
                }}
                handleSaveChanges={deleteDiscount}
                isOpen={deleteModal}
            />
        </div>
    );
};

const DateInput = (props: any) => {
    return (
        <div className=" flex-1 mt-4 w-full ">
            <div className="">
                {props?.label && (
                    <p className="  text-xs mb-2 ml-2 font-semibold">{props.label}</p>
                )}
                <DatePicker
                    dateFormat={"MM/dd/yyyy"}
                    className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none uppercase focus:ring-1 focus:ring-primary-red text-gray-600"
                    onChange={(value: any) => {
                        value && props.onChange(value);
                    }}
                    minDate={props?.minDate}
                    selected={props.value} // Use 'selected' prop instead of 'value' for react-datepicker
                />
            </div>
        </div>
    );
};

export default DiscountManager;
